import { PublicShell } from "../../components/Layouts";

const steps = [
  ["01", "Create your account", "Register with your email and a sponsor's referral code to activate your member workspace."],
  ["02", "Choose a package", "Select the participation tier that matches your pace. All pricing is defined by the administrator and shown transparently."],
  ["03", "Fund with USDT (BEP20)", "Send USDT on BNB Smart Chain to the receiving wallet shown on the deposit page, then submit the transaction hash."],
  ["04", "On-chain verification", "The platform verifies your transfer against the configured contract, wallet and confirmation count before activating the package."],
  ["05", "Daily production", "Once active, your package produces earnings every day until the end of its term."],
  ["06", "Grow your network", "Share your referral link. Four levels of commissions reward your community building, with rates defined by the admin."],
  ["07", "Withdraw to your wallet", "Request a withdrawal to your BEP20 wallet. The administrator reviews the request before releasing funds."],
];

export default function HowItWorks() {
  return (
    <PublicShell>
      <main className="page">
        <div className="page-intro">
          <div className="eyebrow">THE JOURNEY</div>
          <h1>How it<br /><em>works.</em></h1>
          <p>Every step is deliberate: clear information, verifiable deposits, and transparent production. Nothing is hidden behind opaque interfaces.</p>
        </div>
        <div className="steps-grid">
          {steps.map((s, i) => (
            <article key={s[0]} className="step" data-testid={`step-${i}`}>
              <div className="step-number">{s[0]}</div>
              <h3>{s[1]}</h3>
              <p>{s[2]}</p>
            </article>
          ))}
        </div>
      </main>
    </PublicShell>
  );
}
